<template lang="pug">
  .statistics-last-orders
    GenericTable
      tr(slot="thead")
        th ID
        th Size
        th Created
        th Product
        th Locked
        th Owner
        th Description
      tr(v-for="d in data")
        td {{d.id}}
        td {{d.size | number}}
        td {{d.created | date}}
        td
          span(v-if="d.product") {{d.product.name}}
        td
          i(:class="d.isLocked? 'fa fa-lock' : 'fa fa-unlock'")
        td
          span(v-if="d.owner && d.owner.group") {{d.owner.group.name}}
        td {{d.description}}
</template>

<script>
import GenericTable from '@/components/common/GenericTable'
import { numberFilter, dateFilter } from '@/filters/filters'

export default {
  props: {
    data: {
      type: Array
    }
  },
  components: {
    GenericTable
  },
  filters: {
    number: numberFilter,
    date: dateFilter
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/core/statistic/LastOrders.vue